import React, { useState, useEffect } from 'react'
import {
  InsideFooter,
  BoxContainer,
  Button
} from '../../../../../../components'
import { Container, BoxBrand } from './styles'
import ecbrDNA from '../../../../../../assets/Icons/ecbrDna.svg'
import { useInfinitePagination } from '../../../../../../hooks/useInfinitePagination'
import { PaginationOrder } from '../../../../../../constants/pagination'
import ecbrApi from '../../../../../../services/ecbrApi'
import useUrlParam from '../../../../../../hooks/useUrlParam'
import PaymentTable from './PaymentTable'
import {
  CertificateStatusColors,
  getCertificateStatusText
} from '../../../../../../constants/certificate'
import { StatusText } from '../../../../../User/Brands/UserBrandDetails/UserCertificates/styles'

const pagination = { page: 1, take: 10 }

const Overview = () => {
  const [error, setError] = useState('')
  const [companyId, brandId] = useUrlParam('/admin/companies/:id/brands/:id')
  const [searchParameters, setSearchParameters] = useState({
    ...pagination,
    order: PaginationOrder.ASC,
    brandId: brandId || null
  })

  const {
    data: certificates,
    fetchNextPage,
    hasNextPage,
    isLastPage,
    isFetching,
    isLoading,
    refetch
  } = useInfinitePagination(
    'certificates',
    async (params) => {
      const { pageParam = searchParameters.page } = params
      return ecbrApi.certificates.getAll({
        ...searchParameters,
        page: pageParam || searchParameters.page
      })
    },
    {
      enabled:
        searchParameters.companyId !== null &&
        searchParameters.brandId !== null,
      onSuccess: () => {
        setError('')
      },
      onError: () => {
        setError('Não foi possível carregar os dados')
      }
    }
  )

  useEffect(() => {
    setSearchParameters({
      ...searchParameters,
      companyId,
      brandId
    })
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, brandId])

  return (
    <Container>
      <h2>Certificados da Empresa</h2>
      <BoxContainer>
        {error && <p>{error}</p>}
        {!isLoading && !isFetching && !certificates?.length && (
          <p>Nenhum certificado encontrado</p>
        )}
        {certificates?.map?.(({ id, product, status }) => (
          <BoxBrand key={id}>
            <img src={ecbrDNA} alt={product?.description} />
            <h3>{product?.name}</h3>
            <StatusText color={CertificateStatusColors[status]}>
              {getCertificateStatusText(status)}
            </StatusText>
          </BoxBrand>
        ))}
        {hasNextPage && !isLastPage && (
          <Button
            type="button"
            variant="outlined"
            text={isLoading || isFetching ? 'Carregando...' : 'Ver mais'}
            width="200px"
            height="40px"
            onClick={fetchNextPage}
          />
        )}
      </BoxContainer>
      <h2>Pagamentos</h2>
      <PaymentTable />
      <InsideFooter />
    </Container>
  )
}

export default Overview
